const ComponentsLookup = {
  "default-footer": "DefaultFooter3f9bda00E7b54dda93531c749c04470c"
}

export default ComponentsLookup;